/**
 * MEMBERSHIP CONSTANTS
 * 
 * Configurações estáticas para o módulo de Planos (Membership).
 * Membership = template do plano. MemberMembership = contrato do cliente.
 */



export const MEMBERSHIP_TYPES = [
    { value: 'fixed', label: 'Contrato Comum' },
    { value: 'pass', label: 'Pacote de Aulas' }
];

export const DURATION_TYPES = [
    { value: 'monthly', label: 'Meses' },
    { value: 'yearly', label: 'Anos' },
    { value: 'days', label: 'Dias' },
    { value: 'classes', label: 'Aulas' }
];

